import React, { useState, useEffect } from 'react'
import ExamHeadHeader from '../common/ExamHeadHeader'
import Footer from '../common/Footer'
import { baseUrl } from '../../Utility/constants'
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { getSchoolId } from '../../Utility/commonFunctions';

const MarkMaster = () => {
    const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
    const subjectGroupApiUrl = `${baseUrl}/api/CommonMaster/GetSubjectGroupMasters`;

    const [subjects, setSubjects] = useState([]);
    const [subjectGroups, setSubjectGroups] = useState([]);
    const [streams, setStreams] = useState([]);
    const [data, setData] = useState([]);
    const [schoolId, setSchoolId] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [standards, setStandards] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);

    const defaultFormData = {
        id: 0,
        standardId: "",
        streamId: "",
        subjectId: "",
        subjectGroupId: "",
        isUnit1Conducted: false,
        unit1TestMarks: 0,
        unit1Bifocal: 0,
        unit1GraceMarks: 0,
        unit1PassingMarks: 0,

        isUnit2Conducted: false,
        unit2TestMarks: 0,
        unit2Bifocal: 0,
        unit2GraceMarks: 0,
        unit2PassingMarks: 0,

        isTerm1Conducted: false,
        term1Marks: 0,
        term1Bifocal: 0,
        term1GraceMarks: 0,
        term1PassingMarks: 0,

        isFinalConducted: false,
        finalTheory: 0,
        finalOral: 0,
        finalJournal: 0,
        finalProject: 0,
        finalPractical: 0,
        finalGraceMarks: 0,
        finalPassingMarks: 0,

        createdBy: localStorage.getItem("userID"),
        updatedBy: localStorage.getItem("userID"),
        createdOn: new Date().toISOString(),
        updatedOn: new Date().toISOString(),
        isActive: true,
    };

    const [formData, setFormData] = useState({ ...defaultFormData });

    // const [formData, setFormData] = useState({
    //     id: 0,
    //     standardId: "",
    //     streamId: "",
    //     subjectId: "",
    //     subjectGroupId: "",
    //     isUnit1Conducted: false,
    //     unit1TestMarks: 0,
    //     unit1Bifocal: 0,
    //     isUnit2Conducted: false,
    //     unit2TestMarks: 0,
    //     unit2Bifocal: 0,
    //     isTerm1Conducted: false,
    //     term1Marks: 0,
    //     term1Bifocal: 0,
    //     isFinalConducted: false,
    //     finalTheory: 0,
    //     finalOral: 0,
    //     finalJournal: 0,
    //     finalProject: 0,
    //     finalPractical: 0,
    //     createdBy: localStorage.getItem("userID"),
    //     updatedBy: localStorage.getItem("userID"),
    //     createdOn: new Date().toISOString(),
    //     updatedOn: new Date().toISOString(),
    //     isActive: true,
    // });

    const clearForm = () => {
        setFormData({
            ...defaultFormData,
            createdOn: new Date().toISOString(),
            updatedOn: new Date().toISOString(),
        });
    };

    useEffect(() => {
        fetchSubjectGroups();
        fetchData();
        const loadSchoolId = async () => {
            try {
                const school = await getSchoolId();
                if (school !== null && school !== undefined) {
                    setSchoolId(school);
                }
            } catch (error) {
                console.error("Error loading school ID", error);
            }
        };
        loadSchoolId();
    }, []);

    const openAddModal = () => {
        setEditingId(null);
        clearForm();
        setModalOpen(true);
    };

    const openEditModal = (item) => {
        setEditingId(item.id);
        setModalOpen(true);
        fetchDataById(item.id);
    };

    const fetchDataById = async (teacherId) => {
        try {
            const response = await axios.get(`${baseUrl}/api/MarkMaster/${teacherId}`);
            const data = response.data;

            // Ensure subjects & sections are loaded first
            await Promise.all([
                axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?classId=${data.standardId}&streamId=${data.streamId}&subjectGroup=${data.subjectGroupId}`)
                    .then(res => setSubjects(res.data))
            ]);

            // Now set the form data
            setFormData({
                ...defaultFormData,
                ...data,
                unit1TestMarks: data.unit1TestMarks ?? 0,
                unit1Bifocal: data.unit1Bifocal ?? 0,
                unit1GraceMarks:  data.unit1GraceMarks ?? 0,
                unit1PassingMarks:  data.unit1PassingMarks ?? 0,

                unit2TestMarks: data.unit2TestMarks ?? 0,
                unit2Bifocal: data.unit2Bifocal ?? 0,
                unit2GraceMarks:  data.unit2GraceMarks ?? 0,
                unit2PassingMarks:  data.unit2PassingMarks ?? 0,

                term1Marks: data.term1Marks ?? 0,
                term1Bifocal: data.term1Bifocal ?? 0,
                term1GraceMarks: data.term1GraceMarks ?? 0,
                term1PassingMarks: data.term1PassingMarks ?? 0,

                finalTheory: data.finalTheory ?? 0,
                finalOral: data.finalOral ?? 0,
                finalJournal: data.finalJournal ?? 0,
                finalProject: data.finalProject ?? 0,
                finalPractical: data.finalPractical ?? 0, 
                finalGraceMarks: data.finalGraceMarks ?? 0,
                finalPassingMarks: data.finalPassingMarks ?? 0,      

                createdBy: localStorage.getItem("userID"),
                updatedBy: localStorage.getItem("userID"),
                createdOn: new Date().toISOString(),
                updatedOn: new Date().toISOString(),
            });
        } catch (error) {
            toast.error("Error fetching teacher mapping data");
            console.error(error);
        }
    };


    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        setFormData((prev) => ({
            ...prev,
            //[e.target.name]: e.target.value,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            try {
                await axios.delete(`${baseUrl}/api/MarkMaster/${id}`);
                toast.success("Deleted successfully");
                fetchData();
                clearForm();
            } catch (error) {
                toast.error("Failed to delete");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                ...formData,
                schoolId: schoolId,
                createdOn: new Date().toISOString(),
                updatedOn: new Date().toISOString(),
                createdBy: localStorage.getItem("userID"),
                updatedBy: localStorage.getItem("userID"),
                isActive: true,
            };

            if (editingId) {
                await axios.put(`${baseUrl}/api/MarkMaster/${editingId}`, payload);
                toast.success("Details updated successfully");
            } else {
                await axios.post(`${baseUrl}/api/MarkMaster`, payload);
                toast.success("Details added successfully");
            }

            setModalOpen(false);
            fetchData();
            clearForm();
        } catch (error) {
            if (error?.response?.status === 409) {
                toast.error("Details already exist.");
            } else {
                toast.error("Operation failed");
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(`${baseUrl}/api/MarkMaster`);
            setData(response.data || []);
        } catch (error) {
            toast.error("Error fetching data");
        }
    };

    useEffect(() => {
        if (formData.standardId && formData.streamId && formData.subjectGroupId) {
            fetchSubjects();
        }
    }, [formData.standardId, formData.streamId, formData.subjectGroupId]);

    // Subject Selection 
    const fetchSubjects = async () => {
        try {
            const response = await axios.get(
                `${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStreamForMarkMaster?classId=${formData.standardId}&streamId=${formData.streamId}&subjectGroup=${formData.subjectGroupId}`
            );
            setSubjects(response.data);
        } catch (error) {
            console.error("Error fetching subjects", error);
        }
    };

    useEffect(() => {
        axios
            .get(`${baseUrl}/api/StreamMaster`)
            .then((response) => setStreams(response.data))
            .catch(() => console.log("Error fetching stream details"));
    }, []);

    const fetchSubjectGroups = async () => {
        try {
            const url = subjectGroupApiUrl;
            const response = await axios.get(url);
            if (
                response &&
                response.data &&
                response.data.length > 0
            ) {
                setSubjectGroups(response.data);
            }
            else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        }
    };

    // Fetch standards based on schoolId
    useEffect(() => {
        if (schoolId) {
            axios
                .get(`${standardApiUrl}?id=${schoolId}`)
                .then((response) => setStandards(response.data))
                .catch(() => console.log("Error fetching standards"));
        }
    }, [schoolId]);

    return (
        <>
            <ExamHeadHeader />
            <div className="container mt-5 mb-5">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4>Mark Master</h4>
                    <button className="btn btn-primary" onClick={openAddModal}>
                        Add New
                    </button>
                </div>

                <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>#</th>
                            <th>Standard</th>
                            <th>Stream</th>
                            <th>Subject Group</th>
                            <th>Subject</th>
                            <th>Unit 1 <br></br> General - Bifocal</th>
                            <th>Unit 2 <br></br> General - Bifocal</th>
                            <th>Term 1 <br></br> General - Bifocal</th>
                            <th>Final <br></br>Theory-Practical-Oral-Journal-Project</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length ? data.map((item, i) => (
                            <tr key={item.id}>
                                <td>{i + 1}</td>
                                <td>{item.standardName}</td>
                                <td>{item.streamName}</td>
                                <td>{item.subjectGroupName}</td>
                                <td>{item.subjectCode} - {item.subjectName}</td>
                                <td title='IsConducted- Marks - Bifocal Marks'>
                                    {item.isUnit1Conducted ? `${item.unit1TestMarks}-${item.unit1Bifocal}` : "N/A"}
                                </td>
                                <td title='IsConducted- Marks - Bifocal Marks'>
                                    {item.isUnit2Conducted ? `${item.unit2TestMarks}-${item.unit2Bifocal}` : "N/A"}
                                </td>
                                <td title='IsConducted- Marks - Bifocal Marks'>
                                    {item.isTerm1Conducted ? `${item.term1Marks}-${item.term1Bifocal}` : "N/A"}
                                </td>
                                <td title='IsConducted-Theory-Oral-Journal-Project-Practical'>
                                    {item.isFinalConducted ? `${item.finalTheory}-${item.finalPractical}-${item.finalOral}-${item.finalJournal}-${item.finalProject}` : "N/A"}
                                </td>
                                <td>
                                    <button className="btn btn-warning btn-sm me-2" onClick={() => openEditModal(item)}>Edit / View</button>
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}>Delete</button>
                                </td>
                            </tr>
                        )) : <tr><td colSpan="9" className="text-center">No records found</td></tr>}

                    </tbody>
                </table>


                {/* Modal */}
                {modalOpen && (

                    <div
                        className="modal show fade"
                        tabIndex="-1"
                        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-header">
                                        <h5 className="modal-title">{editingId ? "Edit Marks" : "Add Marks"}</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setModalOpen(false)}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Standard</label>
                                                <select
                                                    className="form-select"
                                                    name="standardId"
                                                    value={formData.standardId}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="">Select Standard</option>
                                                    {standards.map((std) => (
                                                        <option key={std.id} value={std.id}>
                                                            {std.standardName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Stream</label>
                                                <select
                                                    className="form-select"
                                                    name="streamId"
                                                    value={formData.streamId}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="">Select Stream</option>
                                                    {streams.map((stream) => (
                                                        <option key={stream.id} value={stream.id}>
                                                            {stream.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Subject Group</label>
                                                <select
                                                    className="form-select"
                                                    value={formData.subjectGroupId}
                                                    name="subjectGroupId"
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select Subject Group</option>
                                                    {subjectGroups.map((group) => (
                                                        <option key={group.subjectGroupId} value={group.subjectGroupId}>
                                                            {group.subjectGroupName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Subject</label>
                                                <select
                                                    className="form-select"
                                                    name="subjectId"
                                                    value={formData.subjectId}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="">Select Subject</option>
                                                    {subjects.map((sub) => (
                                                        <option key={sub.subjectId} value={sub.subjectId}>
                                                            {sub.subjectName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4"><strong></strong></div>
                                            <div className="col-md-1"><strong>General </strong></div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-1"><strong>Bifocal</strong></div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-2"><strong>Passing Marks</strong></div>                                          
                                            {/* <div className="col-md-2"><strong>Grace Marks</strong></div> */}
                                        </div>
                                        <div className="row mb-3">
                                            {/* Unit 1 */}
                                            <div className="col-md-2"><strong>{"Unit 1 =>"} </strong></div>
                                            <div className="col-md-2">
                                                <input type="checkbox" className="form-check-input" name="isUnit1Conducted" checked={formData.isUnit1Conducted} onChange={handleInputChange} />Is Conducted
                                            </div>
                                            <div className="col-md-2">
                                                <input type="number" className="form-control" name="unit1TestMarks" value={formData.unit1TestMarks} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-2">
                                                <input type="number" className="form-control" name="unit1Bifocal" value={formData.unit1Bifocal} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-4">
                                                <input type="number" className="form-control" name="unit1PassingMarks" value={formData.unit1PassingMarks} onChange={handleInputChange} />
                                            </div>
                                            {/* <div className="col-md-2">
                                                <input type="number" className="form-control" name="unit1GraceMarks" value={formData.unit1GraceMarks} onChange={handleInputChange} />
                                            </div> */}
                                            
                                        </div>
                                        <div className="row mb-3">
                                            {/* Unit 2 */}
                                            <div className="col-md-2"><strong>Unit 2 {"=>"} </strong></div>
                                            <div className="col-md-2">
                                                <input type="checkbox" className="form-check-input" name="isUnit2Conducted" checked={formData.isUnit2Conducted} onChange={handleInputChange} />Is Conducted
                                            </div>
                                            <div className="col-md-2">
                                                <input type="number" className="form-control" name="unit2TestMarks" value={formData.unit2TestMarks} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-2">
                                                <input type="number" className="form-control" name="unit2Bifocal" value={formData.unit2Bifocal} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-4">
                                                <input type="number" className="form-control" name="unit2PassingMarks" value={formData.unit2PassingMarks} onChange={handleInputChange} />
                                            </div>
                                            {/* <div className="col-md-2">
                                                <input type="number" className="form-control" name="unit2GraceMarks" value={formData.unit2GraceMarks} onChange={handleInputChange} />
                                            </div> */}
                                            
                                        </div>
                                        <div className="row mb-3">
                                            {/* Term 1 */}
                                            <div className="col-md-2"><strong>Term 1 {"=>"}</strong></div>
                                            <div className="col-md-2">
                                                <input type="checkbox" className="form-check-input" name="isTerm1Conducted" checked={formData.isTerm1Conducted} onChange={handleInputChange} />Is Conducted
                                            </div>
                                            <div className="col-md-2">
                                                <input type="number" className="form-control" name="term1Marks" value={formData.term1Marks} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-2">
                                                <input type="number" className="form-control" name="term1Bifocal" value={formData.term1Bifocal} onChange={handleInputChange} />
                                            </div>
                                            <div className="col-md-4">
                                                <input type="number" className="form-control" name="term1PassingMarks" value={formData.term1PassingMarks} onChange={handleInputChange} />
                                            </div>
                                            {/* <div className="col-md-2">
                                                <input type="number" className="form-control" name="term1GraceMarks" value={formData.term1GraceMarks} onChange={handleInputChange} />
                                            </div> */}
                                            
                                        </div>
                                        <hr></hr>
                                        <div className="row mb-3">
                                            {/* Final */}
                                            <div className="col-md-2"><strong>Final {"=>"}</strong></div>
                                            <div className="col-md-2">
                                                <input type="checkbox" className="form-check-input" name="isFinalConducted" checked={formData.isFinalConducted} onChange={handleInputChange} />Is Conducted
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-3 mb-2">
                                                <label className="form-label">Theory</label>
                                                <input type="number" className="form-control" name="finalTheory" value={formData.finalTheory} onChange={handleInputChange}  />
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="form-label">Practical</label>
                                                <input type="number" className="form-control" name="finalPractical" value={formData.finalPractical} onChange={handleInputChange}  />
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="form-label">Oral</label>
                                                <input type="number" className="form-control" name="finalOral" value={formData.finalOral} onChange={handleInputChange}  />
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="form-label">Journal</label>
                                                <input type="number" className="form-control" name="finalJournal" value={formData.finalJournal} onChange={handleInputChange} />
                                            </div>

                                            <div className="col-md-3 mb-2">
                                                <label className="form-label">Project</label>
                                                <input type="number" className="form-control" name="finalProject" value={formData.finalProject} onChange={handleInputChange} />
                                            </div>

                                            {/* <div className="col-md-3">
                                            <label className="form-label">Grace Marks</label>
                                                <input type="number" className="form-control" name="finalGraceMarks" value={formData.finalGraceMarks} onChange={handleInputChange} />
                                            </div> */}
                                            <div className="col-md-3">
                                            <label className="form-label">Passing Marks</label>
                                                <input type="number" className="form-control" name="finalPassingMarks" value={formData.finalPassingMarks} onChange={handleInputChange} />
                                            </div>

                                        </div>

                                    </div>

                                    <div className="modal-footer">
                                        <button type="submit" className="btn btn-success">
                                            {editingId ? "Update" : "Add"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => setModalOpen(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <ToastContainer position="top-right" autoClose={3000} />
            <Footer />
        </>
    )
}

export default MarkMaster

